<template>
  <v-row >
    <v-col>
      <h2><b>Análise Farmacêutica: </b></h2><p></p>
        <p> {{ item.analise }} </p> 
    </v-col>
    <v-col>
      <h2><b>Médico(a): </b></h2><p></p>
        <p> {{ item.colaborador?.apelido }} - {{ item.colaborador?.especialidade?.nome }} </p> 
    </v-col>
    <v-col>
      <h2><b>Status da Análise: </b></h2><p></p>
        <p> {{ item.status_analise?.nome }}  </p> 
    </v-col>
    <v-col>
      <h2><b>Justificativa: </b></h2><p></p>
        <p> {{ item.justificativa }}  </p> 
    </v-col>
  </v-row>
</template>

<script>

export default {
  name: "AcionamentoExpand",
  props: {
    item: Object,
  },
}
</script>

